// extracted by mini-css-extract-plugin
module.exports = {"ButtonPane":"OkNavigationButtons_ButtonPane__3nvcv","Alert":"OkNavigationButtons_Alert__kbpa5","Info":"OkNavigationButtons_Info__1LmMC"};